import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import SignInPage from './auth/SignInPage'

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth()

  // Show loading while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-white text-lg">Loading...</div>
      </div>
    )
  }

  // Show sign-in page if not authenticated
  if (!user) {
    return <SignInPage />
  }

  // Show protected content if authenticated
  return children
}

export default ProtectedRoute